import { render } from "./CalendarScreen.vue?vue&type=template&id=7bdfc930&scoped=true"
import script from "./CalendarScreen.vue?vue&type=script&lang=js"
export * from "./CalendarScreen.vue?vue&type=script&lang=js"

import "./CalendarScreen.vue?vue&type=style&index=0&id=7bdfc930&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdfc930"]])

export default __exports__